const dev = {
    region:"us-east-2",
    poolId:"us-east-2_8TXznTY2x",
    roleArn:"arn:aws:cognito-idp:us-east-2:789112514466:userpool/us-east-2_8TXznTY2x",
    clientId:"5q4jj9sqi8mhsv7uskuv3j70n0",
};

const qa = {
    region:"us-east-2",
    poolId:"us-east-2_vAyJajhL1",
    roleArn:"arn:aws:cognito-idp:us-east-2:789112514466:userpool/us-east-2_vAyJajhL1",
    clientId:"5ohpn8qif603mg21pfl6mnqf9a",
};
const uat = {
    region:"us-east-2",
    poolId:"us-east-2_RqYFLogrn",
    roleArn:"arn:aws:cognito-idp:us-east-2:933258960133:userpool/us-east-2_RqYFLogrn",
    clientId:"6dmg2a99r4cr702f5ulmfgorqu",
};
const prod = {
    region:"us-east-1",
    poolId:"us-east-1_yTJh78DZU",
    roleArn:"arn:aws:cognito-idp:us-east-1:510863482469:userpool/us-east-1_yTJh78DZU",
    clientId:"7d8ja3us768tc6u5opj4n56coa",
};

export  {
    dev, qa,uat,prod
}
